"use client";

import { useRef } from "react";
import FloatingTooltipContent from "@/components/ui/floating-tooltip-content";
import { useFloatingTooltip } from "@/components/ui/use-floating-tooltip";
import { CircleHelp } from "lucide-react";
import { cn } from "@/lib/utils";

export default function HelpTooltip({
  text,
  className,
  inheritColor = false,
}: {
  text: string;
  className?: string;
  /** Use the parent element's `color` (e.g. verdict tone). */
  inheritColor?: boolean;
}) {
  const triggerRef = useRef<HTMLButtonElement>(null);
  const { mounted, visible, position, open, close } =
    useFloatingTooltip(triggerRef);

  return (
    <>
      <button
        ref={triggerRef}
        type="button"
        aria-label={text}
        className={cn(
          "inline-flex size-5 shrink-0 cursor-help items-center justify-center rounded-full",
          inheritColor
            ? "text-inherit hover:opacity-80"
            : "text-muted-foreground hover:text-foreground",
          className,
        )}
        onMouseEnter={open}
        onMouseLeave={close}
        onFocus={open}
        onBlur={close}
      >
        <CircleHelp className="size-3.5" aria-hidden />
      </button>
      <FloatingTooltipContent
        text={text}
        position={position}
        visible={visible}
        mounted={mounted}
      />
    </>
  );
}
